const l = {
  lng: "ru",
  style: "decimal"
};
function s(t, n) {
  const o = {
    ...l,
    ...n
  }, { lng: e, ...r } = o;
  return new Intl.NumberFormat(e, r).format(t);
}
export {
  s as formatDecimal
};
